
import { post, get, sendDelete } from '../helpers/api.helper';

export async function createPayment(paymentBody) {
    try {
        return await post(`pagamentos`, paymentBody);
    } catch (error) {
        console.error('[createPayment] erro ao processar request');
    }
}

export async function getPayments(customerId) {
    try {
        return await get(`pagamentos/list`);
    } catch (error) {
        console.error('[getPayments] erro ao processar request');
    }
}

export async function deleteItem(id) {
    try {
        return await sendDelete(`pagamentos/${id}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}